// extracted by mini-css-extract-plugin
module.exports = {"banner":"_D6ukN6M","expand":"_2YfBOoE"};